import request from "./request";

function formatUrl({ url, pathVariables }) {
  let formattedUrl = url;
  Object.entries(pathVariables || {}).forEach(([k, v]) => {
    formattedUrl = formattedUrl.replace(`:${k}`, encodeURIComponent(v));
  });

  return formattedUrl;
}

export function get({ url, requestParams, pathVariables }) {
  const editedUrl = formatUrl({
    url,
    pathVariables,
  });

  return request.get(editedUrl, {
    params: requestParams,
  });
}

export function postJson({ url, data, params, pathVariables }) {
  const editedUrl = formatUrl({
    url,
    pathVariables,
  });

  return request.post(editedUrl, JSON.stringify(data), {
    params,
    headers: {
      "content-type": "application/json",
    },
  });
}

export function putJson({ url, data, params, pathVariables }) {
  const editedUrl = formatUrl({
    url,
    pathVariables,
  });

  return request.put(editedUrl, JSON.stringify(data), {
    params,
    headers: {
      "content-type": "application/json",
    },
  });
}

export function patchJson({ url, params, pathVariables, data }) {
  const editedUrl = formatUrl({
    url,
    pathVariables,
  });

  return request.patch(editedUrl, JSON.stringify(data), {
    params,
    headers: {
      "content-type": "application/json",
    },
  });
}

export function deleteRequest({ url, params, pathVariables }) {
  const editedUrl = formatUrl({
    url,
    pathVariables,
  });

  return request.delete(editedUrl, {
    params,
  });
}
